<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <!-- Brand -->
        <router-link :to="{name: 'adhocSession'}" class="h4 mb-0 text-uppercase d-none d-lg-inline-block">
          Add Adhoc Session
        </router-link>
        <user-data></user-data>
        
      </div>
    </nav>
    <!-- Page content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row mb-5 mb-xl-0">
        <div class="col-md-3">
          <b-form-group label="Site" label-for="site">
            <b-form-select id="site" required
              v-model="form.site_id" class="form-control-alternative"
              @change="onSiteChange">
              <option value="null" disabled selected>Please select Site</option>
              <option v-for="site in coPropList.data" :key="site.id" :value="site.id">
                {{ site.name }}
              </option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Meter Type" label-for="meterType">
            <b-form-select id="meterType" required
              v-model="form.service_type_id" class="form-control-alternative"
              :disabled="!form.site_id" @change="onMeterTypeChange">
              <option value="null" disabled selected>Please select Meter</option>
              <option v-for="meter in meterList" :key="meter.id" :value="meter.id">
                {{ meter.service_name }}
              </option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
            <b-form-group label="Lot No" label-for="lotNo">
                <b-form-select id="lotNo" required
                v-model="form.lot_id" class="form-control-alternative"
                :disabled="!form.service_type_id">
                  <option value="null" disabled selected>Please select Lot</option>
                  <option v-for="lot in lotList.data" :key="lot.id" :value="lot.id">
                    {{ lot.lot_no }}
                  </option>
                </b-form-select>
            </b-form-group>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Enter Reading</h3>
                </div>
                <div class="col text-right">
                  <router-link :to="{name: 'adhocSession'}" class="btn btn-info"> Back </router-link>
                </div>
              </div>
            </div>
            <div class="card-body border-0">
                <div class="row">
                    <b-form-group label="Previous Reading" class="col-md-3">
                        <b-form-input type="text" value="352" disabled required> </b-form-input>
                    </b-form-group>
                    <b-form-group label="New Reading" label-for="newReading" class="col-md-3">
                        <b-form-input type="text" value="592" id="newReading" required placeholder="Enter New Reading">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="Bill Value" label-for="newReading" class="col-md-3">
                        <b-form-input type="text" value="250" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label=" " class="col-md-3">
                        <b-button type="submit" class="mt-4" variant="success">Generate Bill</b-button>
                    </b-form-group>
                    
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
  import userData from '@/pages/Common/userData';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    components: {
      userData,
      datePicker
    },
    data () {
      return {
        options: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
        },
        form : {
          site_id: null,
          service_type_id: null,
          lot_id: null,
          fromDate: new Date(),
          toDate: new Date(),
        },
        fields: [
          {
            key: 'lotNo',
            label: 'Lot No',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'ownerName',
            label: 'Owner Name',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'meterType',
            label: 'Meter Type',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'date',
            label: 'Date',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'totalConsumption',
            label: 'Total Consumption',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'loadCharge',
            label: 'Load Charge',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'billValue',
            label: 'Bill Value',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'actions',
            label: 'Actions',
            sortable: false,
            'class': 'text-center'
          },
        ],
        items: [
          {lotNo:1, ownerName: 'Owner Name', loadCharge: 213, totalConsumption: 300, meterType: 'Gas', date: '10/10/2018', billValue: "Rs. 250"},
          {lotNo:2, ownerName: 'Owner Name', loadCharge: 243, totalConsumption: 280, meterType: 'Water', date: '11/10/2018', billValue: "Rs. 68"},
          {lotNo:3, ownerName: 'Owner Name', loadCharge: 218, totalConsumption: 298, meterType: 'Electricity', date: '13/10/2018', billValue: "Rs. 235" },
        ]
      }
    },
    computed: {
      ...mapGetters('coprops', ['coPropList', 'meterList', 'lotList']),
    },
    methods: {
      ...mapActions('coprops', ['ALL_CO_PROP_LIST', 'ALL_METER_LIST', 'ALL_LOT_LIST']),

      async onSiteChange () {
        if (this.form.site_id) {
          await this.ALL_METER_LIST({ site_id: this.form.site_id })
        }
        this.form.service_type_id = null
        this.form.lot_id = null
      },
      async onMeterTypeChange () {
        if (this.form.site_id && this.form.service_type_id) {
          await this.ALL_LOT_LIST({
            site_id: this.form.site_id,
            service_type_id: this.form.service_type_id
          })
        }
        this.form.lot_id = null
      }
    },
    created () {
      if (!localStorage.token) {
        localStorage.clear()
        next({
          name: 'adminLogin'
        })
      } else {
        if(localStorage.roleId == 1){
          this.$router.replace({name: "dashboard"});
        }
        this.ALL_CO_PROP_LIST()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Admin/addAdhocSession.vue